module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-news",
    class: {
      loading: _vm.list.loading
    }
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_vm._t("default", null, {
    data: _vm.parameters
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('ul', _vm._l((_vm.list.results.items), function(item) {
    return _c('li', {
      key: item.id,
      class: [{
          'no-image': !item.image,
        },
        item.themeColor.ClassName
      ]
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [(item.image) ? _c('sky-crop', {
      attrs: {
        "mode": "cover",
        "src": item.image.skyCropUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('time', {
      class: {
        'padding-left': item.eventdate
      }
    }, [(item.eventdate) ? _c('sky-svg', {
      attrs: {
        "name": "calendar"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.newsdate || item.eventdate)
      }
    })], 1), _vm._v(" "), (item.eventdate) ? _c('div', {
      staticClass: "event-info"
    }, [_c('div', [_c('sky-svg', {
      attrs: {
        "name": "marker"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.address)
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('h2', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.teaser) ? _c('p', {
      domProps: {
        "textContent": _vm._s(item.teaser)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sub"
    }, [(item.tag) ? _c('div', {
      staticClass: "tag",
      domProps: {
        "textContent": _vm._s(item.tag)
      }
    }) : _vm._e(), _vm._v(" "), (item.url) ? _c('ro-read-more', {
      attrs: {
        "href": item.url,
        "button-only": true
      }
    }) : _vm._e()], 1)])], 1)])
  })), _vm._v(" "), (_vm.list.results.pagination.total > _vm.list.results.items.length) ? _c('div', {
    staticClass: "search-more"
  }, [(_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('button', {
    staticClass: "search-next",
    on: {
      "click": _vm.more
    }
  }, [_c('span', [_c('i', [_vm._v("Vis flere")]), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  })], 1)]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-0933fae8"}!./scripts/sky-news/sky-news.html
// module id = 360
// module chunks = 1